import {remCalc} from '../../_utils'

/**
 * the out of stock component style
 */
export default {
    baseStyle: {
        icon: {
            color: 'white',
            fill: 'text.default',
            boxSize: remCalc(16),
            cursor: 'initial',
            borderRadius: remCalc(3),
            w: 'iconsSize.small',
            h: 'iconsSize.small',
        },
        text: {
            color: 'text.default',
            fontWeight: 'bold',
            marginTop: remCalc(2),
            marginLeft: remCalc(8),
            textAlign: 'center',
            textStyle: 'body-small',
        },
    },
    variants: {
        outOfStock: {
            icon: {fill: 'text.danger', backgroundColor: 'text.danger'},
            text: {color: 'text.danger'},
        },
        lastFewItems: {
            icon: {backgroundColor: 'text.default', color: 'text.inverse'},
        },
        'braun-out-of-stock': {
            icon: {
                fill: 'text.danger',
                backgroundColor: null,
                verticalAlign: 'middle',
                borderRadius: remCalc(0),
            },
            text: {
                color: 'text.danger',
                fontWeight: 'light',
                textStyle: 'body-xsmall',
                marginTop: remCalc(0),
            },
        },
        'braun-last-few-items': {
            icon: {backgroundColor: 'null', color: 'text.inverse'},
            text: {fontWeight: 'light', textStyle: 'body-xsmall', marginTop: remCalc(0)},
        },
        selector: {
            icon: {
                display: 'none',
            },
            text: {
                margin: 0,
                color: 'text.inverse',
                textStyle: 'body-xsmall',
                lineHeight: remCalc(16),
                backgroundColor: 'text.secondary',
                paddingX: remCalc(4),
                paddingY: remCalc(2),
                borderRadius: remCalc(4),
            },
        },
    },
    parts: ['icon', 'text'],
}
